export default "__VITE_ASSET__B8m8hmav__"